export enum Country {
  NORWAY = '+44',
}
